import type { MutationResolvers } from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { setTempLayouts } from '../../../../Stores'

export const tempSaveLayoutsResolver: MutationResolvers<ApolloResolverContext>['tempSaveLayouts'] = (
    _root,
    { layouts },
) => {
    console.debug('io-dashboards tempSaveLayoutsResolver deprecated, use tempLayouts store')
    setTempLayouts(layouts)

    return true
}
